/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);return k;};}
var TR=window.TR;
/* i18n helper */
if(typeof window!=="undefined" && typeof window.T==="undefined"){window.T=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var T=window.T;
// main.js — API client (credentials + CSRF), auth guard, nav, site selector.
window.GS = window.GS || {};
GS.apiBase = (document.querySelector('meta[name="gs-api"]')||{}).content || '';
GS.csrf = null; GS.user = null; GS.site = null; GS.sites = [];

/* Numeric id of the selected site, derived from GS.site (a public key) each time it is asked for.
   Derived rather than stored: GS.site is assigned in five different places, and a parallel
   GS.siteId would be correct at four of them and stale at the fifth. */
GS.siteIdNow = function(){
  try {
    var s = (GS.sites || []).filter(function(x){ return x.public_key === GS.site; })[0] || (GS.sites || [])[0];
    return s ? s.id : 0;
  } catch (e) { return 0; }
};

GS.api = async function(path, opts = {}){
  /* Nine plugin settings templates post to /plugins/config without a site_id — they predate the
     site selector, and because none of them was reachable until now, nobody hit the failure
     (owned_site(uid, 0) refuses it). Their JS builds its own body and cannot be edited from here,
     so the selected site is folded into that body on the way past. Body, not header: a custom
     header would need a CORS allow-list entry in four files, and getting that wrong breaks every
     request in the app rather than this one. */
  if (path.indexOf('/plugins/config') === 0 && typeof opts.body === 'string') {
    try {
      const b = JSON.parse(opts.body);
      if (b && typeof b === 'object' && !b.site_id && GS.siteIdNow()) {
        b.site_id = GS.siteIdNow();
        opts = Object.assign({}, opts, { body: JSON.stringify(b) });
      }
    } catch (e) { /* not JSON — leave it exactly as the caller built it */ }
  }
  const res = await fetch(GS.apiBase + path, Object.assign({
    credentials: 'include',
    headers: Object.assign({ 'Content-Type':'application/json' },
      GS.csrf ? { 'X-CSRF-Token': GS.csrf } : {},
      /* NOTHING ELSE GOES IN HERE without being added to the API's CORS allow-list first.
         app.ghoststat.me and api.ghoststat.me are different origins, so any header outside the
         simple set forces a preflight, and a preflight that does not list the header fails the
         request outright — not the one call that wanted it, EVERY call. Adding X-GS-Site-Id here
         took the whole app down: /plugins, /me/limits and every plugin endpoint died at once.
         The allow-list is declared in four separate places (api/bootstrap.php, api/.htaccess and
         twice in api/lib/Security.php), so a new header means four edits and any miss reproduces
         this. If a value has to reach the server, put it in the body or the query string. */
      opts.headers || {})
  }, opts));
  let data = null; try { data = await res.json(); } catch (e) {}
  if (res.status === 403 && data && data.error === 'readonly_demo' && window.GSUI && GSUI.toast) {
    GSUI.toast(data.message || 'Demo account — changes are disabled.', 'warning');
  }
  /* A plugin page whose OWN data endpoint reports plugin_not_loaded means the plugin is deployed
     (app/index.php rendered its page shell — the app shell has no server session, so GS_PLUGIN keys
     off the file existing, not your grant) but is not enabled or granted to your account. Show one
     clear panel over the empty body instead of a broken-looking screen. Cross-plugin calls that are
     merely unavailable use a different code (plugin_not_enabled_for_site) and never trigger this. */
  if (data && data.ok === false && data.error === 'plugin_not_loaded' && path.indexOf('/plugin/') === 0) {
    try { GS.pluginNotEnabled(data.plugin || (path.split('/')[2] || '')); } catch (e) {}
  }
  return { ok: res.ok, status: res.status, data };
};

/* Graceful "this plugin is not enabled for you" panel. Fires only when the FAILING plugin is the one
   whose page you are on (main[data-gs-plugin]) — so a cross-plugin call never blanks the page — and
   only on plugin pages (elsewhere there is no such <main>, so it is a no-op). Reuses the not-found
   card styling (.gs-nf) for one consistent visual. Idempotent. */
GS.pluginNotEnabled = function(slug){
  var main = document.querySelector('main[data-gs-plugin]');
  if (!main) return;
  var page = main.getAttribute('data-gs-plugin');
  if (!slug || !page || slug !== page) return;           // only the page's own plugin
  if (main.querySelector('.gs-pne')) return;              // once
  var name = String(page).replace(/[-_]+/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
  for (var i = 0; i < main.children.length; i++) main.children[i].style.display = 'none';  // hide the empty body
  var wrap = document.createElement('div'); wrap.className = 'gs-pne';
  var card = document.createElement('div'); card.className = 'gs-card';
  var body = document.createElement('div'); body.className = 'gs-card-body gs-nf';
  var ic = document.createElement('div'); ic.className = 'gs-nf-icon'; ic.setAttribute('aria-hidden','true');
  ic.innerHTML = '<i class="bi bi-lock"></i>';
  var h = document.createElement('h2');
  h.textContent = '\u201C' + name + '\u201D isn\u2019t enabled for your account';
  var para = document.createElement('p');
  para.textContent = 'This plugin is part of GhostStat, but it has not been turned on for your account. '
                   + 'Enable it from the plugins page, or ask an admin if you expected to have it.';
  var act = document.createElement('div'); act.className = 'gs-nf-actions';
  act.innerHTML = '<a class="gs-btn gs-btn-primary" href="/plugins">'+TR('js.browse_plugins')+'</a>'
                + '<a class="gs-btn" href="/dashboard">'+TR('js.back_to_dashboard')+'</a>';
  body.appendChild(ic); body.appendChild(h); body.appendChild(para); body.appendChild(act);
  card.appendChild(body); wrap.appendChild(card); main.appendChild(wrap);
};

/* Read-only DEMO mode (role='readonly'). The server is the real guard — it rejects every write; this
   is the UX layer: a banner plus disabled save/delete/connect buttons so a visitor isn't clicking
   into 403s. The counter customizer is the one place they may play, so it's left untouched. */
function applyReadonlyMode(){
  var path = location.pathname + location.search;
  if (/counter-customizer/.test(path)) return;                 // the sandbox
  function paint(){
    if (!document.querySelector('.gs-ro-banner') && document.body){
      var b = document.createElement('div');
      b.className = 'gs-ro-banner';
      b.setAttribute('style','position:sticky;top:0;z-index:60;background:#FEF3C7;color:#92400E;'
        + 'border-bottom:1px solid #FDE68A;padding:8px 16px;font-size:13px;font-weight:600;text-align:center');
      b.appendChild(document.createTextNode('Demo account — explore anything, but changes are disabled. '));
      // the shop these numbers come from: a visit there shows up in this demo a minute later
      var a = document.createElement('a');
      a.href = GS_DEMO_SHOP_URL; a.target = '_blank'; a.rel = 'noopener';
      a.className = 'gs-ro-shop';
      a.setAttribute('style','color:#92400E;text-decoration:underline;white-space:nowrap');
      a.textContent = 'Visit the Harbor Roast shop \u2197';
      b.appendChild(a);
      document.body.insertBefore(b, document.body.firstChild);
    }
    // saves, delete-account, ecosystem connect/grant/create
    var sel = '[data-gs$="save"],[data-gs*="-save"],[data-gs="del-btn"],[data-gs^="eco-create"],'
            + '[data-gs^="eco-grant"],[data-gs^="eco-connect"],[data-gs*="delete-account"]';
    document.querySelectorAll(sel).forEach(function(el){
      if (el.dataset.roDone) return; el.dataset.roDone = '1';
      el.disabled = true; el.setAttribute('aria-disabled','true');
      el.style.opacity = '.5'; el.style.pointerEvents = 'none';
      el.title = 'Disabled in the demo account';
    });
    // Ecosystem: connecting is a partner OAuth GET redirect the server guard can't intercept, so hide
    // the nav entry outright (ecosystem.js also renders the Connect button inert for read-only).
    document.querySelectorAll('a.gs-nav-link[href="/ecosystem"],a[href="/ecosystem"]').forEach(function(a){
      var li = a.closest('li'); if (li) li.style.display = 'none';
      a.style.display = 'none'; a.hidden = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  setTimeout(paint, 1200);   // catch controls rendered after their data loads
}

/* The read-only demo account's own visits are measured with GhostStat itself, under the same site
   as ghoststat.me, so the owner sees in his normal reports how people use the app (and where the
   app's own UX trips them up). Only for role 'readonly' — real customers' app sessions are never
   tracked. The script is the ordinary public snippet; its key is public by design. */
var GS_DEMO_TRACK_KEY = 'nRfoqfNBv8OY5zqoXHSXrV3t';
var GS_DEMO_SHOP_URL = 'https://harborroast.ghoststat.me/';
function trackDemoVisit(){
  /* Marked with an id, NOT a data-* attribute: gs.js reads every data-<name>="1" on its own tag as
     "load plugin <name>", so data-gs-demo-track="1" made it fetch /plugins/gs-demo-track/tracking.js (404). */
  if (!GS_DEMO_TRACK_KEY || document.getElementById('gs-demo-track')) return;
  var s = document.createElement('script');
  s.defer = true;
  s.id = 'gs-demo-track';
  s.setAttribute('data-site', GS_DEMO_TRACK_KEY);
  s.setAttribute('data-api', 'https://api.ghoststat.me');
  s.src = 'https://cdn.ghoststat.me/gs.js';
  document.head.appendChild(s);
}

document.addEventListener('DOMContentLoaded', async () => {
  GSUI.qa('[data-gs="logout"]').forEach(a => a.addEventListener('click', async e => {
    e.preventDefault(); await GS.api('/auth/logout', { method:'POST' }); location.href = '/login';
  }));

  if (/^\/(login|register|forgot-password|verify-email)\b/.test(location.pathname)
      || /page=(login|register|forgot-password|verify-email)/.test(location.search)) return;
  // public stats: /public-stats?s=KEY is viewable without an account
  if (/^\/public-stats\b/.test(location.pathname) && /[?&]s=/.test(location.search)) return;

  const me = await GS.api('/auth/me');
  /* Not signed in: back to this exact page afterwards (path, ?s=site, #tab), e.g. the "Get my report key" link from
     the ExpressionEngine add-on → /software-development?s=KEY#connect. The login page only follows local paths. */
  if (!me.ok || !me.data || !me.data.user) {
    var _here = location.pathname + location.search + location.hash;
    location.href = (_here && _here !== '/' && !/^\/(dashboard)?$/.test(location.pathname)) ? '/login?return=' + encodeURIComponent(_here) : '/login';
    return;
  }
  GS.user = me.data.user; GS.csrf = me.data.csrf; GS.tz = (GS.user && GS.user.timezone) || 'UTC';
  GS.readonly = !!(GS.user && GS.user.role === 'readonly');
  if (GS.readonly) {
    document.body.classList.add('gs-readonly');
    applyReadonlyMode();
    trackDemoVisit();
  }
  /* Clock format alongside the timezone, so every renderer can ask one place instead of guessing from
     the browser locale — which is how a 24-hour account ends up reading 3:07 PM. */
  GS.timeFormat = (GS.user && GS.user.time_format === '12') ? '12' : '24';
  const em = GSUI.gs('me-email'); if (em) em.textContent = GS.user.email;
  (function(){
    const nm = GS.user.name || (GS.user.email||'').split('@')[0];
    const ini = (GS.user.name || GS.user.email || '?').charAt(0).toUpperCase();
    const url = GS.user.avatar ? ((GS.apiBase||'') + GS.user.avatar) : '';
    const mn = GSUI.gs('menu-name'); if (mn) mn.textContent = nm;
    const btn = GSUI.gs('avatar-initial'); if (btn) btn.innerHTML = url ? ('<img src="'+url+'" alt="">') : ini;
    const ma = GSUI.gs('menu-avatar'); if (ma) ma.innerHTML = url ? ('<img src="'+url+'" alt="" style="width:100%;height:100%;border-radius:50%;object-fit:cover">') : ini;
  })();
  if (GS.user && (GS.user.role === 'admin')) document.querySelectorAll('[data-admin-only]').forEach(function(el){ el.classList.remove('d-none'); });

  const s = await GS.api('/sites');
  if (s.ok && s.data && s.data.sites) {
    GS.sites = s.data.sites;
    const list = GSUI.gs('site-list');
    if (GS.sites.length) {
      var _sp = (location.search.match(/[?&]s=([A-Za-z0-9_-]+)/)||[])[1]
                || (function(){ try{ return localStorage.getItem('gs_site'); }catch(e){ return null; } })();
      GS.site = (_sp && GS.sites.some(function(x){return x.public_key===_sp;})) ? _sp : GS.sites[0].public_key;
      try{ localStorage.setItem('gs_site', GS.site); }catch(e){}   // remember across page loads
      var _cs = GS.sites.find(function(x){return x.public_key===GS.site;}) || GS.sites[0];
      const nm = GSUI.gs('site-name'); if (nm) nm.textContent = _cs.name; }
    if (list) list.innerHTML = GS.sites.map(x =>
      `<li><a class="dropdown-item gs-site-item${x.public_key===GS.site?' gs-site-active':''}" href="#" data-key="${x.public_key}" title="${(x.domain||x.name||'').replace(/"/g,'&quot;')}"><span class="gs-site-nm">${x.name}</span><span class="gs-site-live" data-live-key="${x.public_key}"></span></a></li>`).join('')
      || `<li><span class="dropdown-item-text small">${T('nav.no_sites')}</span></li>`;
    (function loadSiteActivity(){
      GS.api('/sites/overview').then(function(r){
        if(!r || !r.ok || !r.data || !r.data.sites) return;
        r.data.sites.forEach(function(site){
          var el = list.querySelector('[data-live-key="'+site.public_key+'"]'); if(!el) return;
          var row = el.closest('.gs-site-item');
          var v = (+site.visits||0), d = (+site.d_visits||0);
          var dir = d > 0 ? 'up' : (d < 0 ? 'down' : 'flat');
          if (row) { row.classList.remove('gs-trend-up','gs-trend-down','gs-trend-flat'); row.classList.add('gs-trend-'+dir); }
          var arrow = dir==='up' ? '\u25B2' : (dir==='down' ? '\u25BC' : '\u2013');
          var pct = (dir==='flat') ? '' : (Math.abs(d)+'%');
          var trend = '<span class="gs-site-trend '+dir+'"><span class="gs-site-arrow">'+arrow+'</span>'+(pct?'<span class="gs-site-pct">'+pct+'</span>':'')+'</span>';
          el.innerHTML = '<span class="gs-site-visits" title="'+T('nav.visits_today')+'">'+v.toLocaleString()+'</span>'+trend;
        });
      }).catch(function(){});
    })();
    GSUI.qa('[data-gs="site-list"] a').forEach(a => a.addEventListener('click', e => {
      e.preventDefault(); GS.site = a.dataset.key; GSUI.gs('site-name').textContent = a.textContent;
      try{ localStorage.setItem('gs_site', GS.site); }catch(_){}
      var _u = new URL(location.href); _u.searchParams.set('s', GS.site);   // reload this page for the chosen site
      location.assign(_u.pathname + _u.search + _u.hash);
    }));
  }

  // populate any <select data-gs="site-picker"> and keep GS.site in sync
  GSUI.qa('[data-gs="site-picker"]').forEach(sel=>{
    sel.innerHTML = GS.sites.map(x=>`<option value="${x.public_key}">${x.name}</option>`).join('');
    sel.value = GS.site || '';
    sel.addEventListener('change', ()=>{ GS.site = sel.value; try{localStorage.setItem('gs_site',GS.site)}catch(e){} document.dispatchEvent(new CustomEvent('gs:site-change')); });
  });
  // generic settings left-menu switching (site-settings + any .gs-settings page)
  GSUI.qa('.gs-settings-nav a[data-sec]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault();
    GSUI.qa('.gs-settings-nav a[data-sec]').forEach(function(x){x.classList.remove('on')}); a.classList.add('on');
    GSUI.qa('.gs-settings-body section[data-panel]').forEach(function(sec){ sec.hidden = sec.dataset.panel!==a.dataset.sec; });
  })});
  // ---- notifications bell (global) ----
  (function initNotifications(){
    var menu=GSUI.gs('notif-menu'); if(!menu) return;
    var listEl=GSUI.gs('notif-list'), countEl=GSUI.gs('notif-count'), allBtn=GSUI.gs('notif-readall');
    function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
    function setCount(n){ if(countEl){ if(n>0){countEl.textContent=n>99?'99+':n; countEl.hidden=false;} else countEl.hidden=true; }
      if(allBtn) allBtn.classList.toggle('d-none', n<=0); }
    function render(items){ if(!listEl) return;
      if(!items.length){ listEl.innerHTML='<div class="gs-notif-empty">You\u2019re all caught up.</div>'; return; }
      listEl.innerHTML=items.map(function(n){ return '<a class="gs-notif-item'+(n.read?'':' unread')+'" href="'+esc(n.url||'#')+'" data-id="'+n.id+'">'
        +'<span class="gs-notif-dot"></span><span class="gs-notif-body"><b>'+esc(n.title)+'</b>'
        +(n.body?'<span>'+esc(n.body)+'</span>':'')+'<small>'+esc(n.ago||'')+'</small></span></a>'; }).join('');
      GSUI.qa('.gs-notif-item',listEl).forEach(function(a){ a.addEventListener('click',async function(e){
        var id=+a.dataset.id;
        if(a.classList.contains('unread')){ a.classList.remove('unread');
          var r=await GS.api('/me/notifications/read',{method:'POST',body:JSON.stringify({id:id})}); if(r.ok&&r.data) setCount(r.data.unread); }
        var href=a.getAttribute('href'); if(!href||href==='#') e.preventDefault();
      }); });
    }
    // a request cut off (page left, laptop asleep, network blip) is not an error worth a console line: try next minute
    async function load(){ var r; try { r=await GS.api('/me/notifications'); } catch(e){ return; }
      if(!r.ok||!r.data){ if(listEl) listEl.innerHTML='<div class="gs-notif-empty">Couldn\u2019t load notifications.</div>'; return; }
      setCount(r.data.unread||0); render(r.data.notifications||[]); }
    if(allBtn) allBtn.addEventListener('click',async function(){ var r=await GS.api('/me/notifications/read-all',{method:'POST',body:'{}'});
      if(r.ok){ setCount(0); GSUI.qa('.gs-notif-item.unread',listEl).forEach(function(x){x.classList.remove('unread');}); } });
    load(); setInterval(load, 60000);
  })();

  // Goal toast hook — the goal plug-in (added later) calls GS.goalToast({title,url}).
  GS.goalToast = function(goal){ if(goal && GSUI.toast) GSUI.toast((goal.title||'Goal in progress'), 'success'); };

  /* ---- deep-link vocabulary ------------------------------------------------
     Every page invented its own name for the same thing. Visitor Intelligence reads `id`,
     User Flow reads `visitor_id`, Identity Graph reads any of `id`/`vid`/`visitor_id`, Session
     Recordings reads `id` for a SESSION, and Heatmaps reads `page` where everyone else writes
     `page_url`. So a link that says "open this visitor over there" arrived with a parameter the
     destination had never heard of, and the page opened on its default view as though nothing had
     been passed — silently, which is why it looked like the link simply did nothing.

     Rather than teach twenty senders twenty vocabularies, translate once, here, before any page
     script reads the URL. Aliases are ADDED, never removed, so anything already reading the old
     name keeps working. Unknown extras (persona, intent_score, journey_stage…) are left alone:
     they are context a receiver may or may not use, and passing them costs nothing. */
  GS.deepLinkAliases = {
    'visitor-intelligence': { id: ['visitor_id', 'vid', 'vh', 'visitor'], session_id: ['sid', 'session'] },
    'identity-graph':       { id: ['vid', 'vh', 'visitor'], session_id: ['sid', 'session'] },
    'ux-auditor':           { id: ['audit_id'] },
    'session-recordings':   { id: ['session_id', 'sid', 'session'], page: ['page_url', 'path', 'url'] },
    'heatmaps':             { page: ['page_url', 'path', 'url'] },
    'user-flow':            { visitor_id: ['id', 'vid', 'vh', 'visitor'], session_id: ['sid', 'session'] },
    'geo':                  { country: ['country_code', 'cc'], region: ['state', 'province'], city: ['city_name'] },
    'funnels':              { id: ['funnel_id'] }
  };
  GS.normalizeDeepLink = function () {
    try {
      var page = (location.pathname || '/').replace(/^\/+|\/+$/g, '').split('/')[0];
      var map = GS.deepLinkAliases[page];
      if (!map) return false;
      var qs = new URLSearchParams(location.search), changed = false;
      for (var canon in map) {
        if (!Object.prototype.hasOwnProperty.call(map, canon)) continue;
        if (qs.get(canon)) continue;                   // the sender already spoke the local dialect
        var alts = map[canon];
        for (var i = 0; i < alts.length; i++) {
          var v = qs.get(alts[i]);
          if (v !== null && v !== '') { qs.set(canon, v); changed = true; break; }
        }
      }
      if (!changed) return false;
      history.replaceState(null, '', location.pathname + '?' + qs.toString() + location.hash);
      return true;
    } catch (e) { return false; }
  };

  /**
   * normalizeDeepLink translates the NAME a sender used into the one the receiver reads. It cannot
   * make a receiver that reads nothing start reading. Several did exactly that: content-intel,
   * dropoff-risk and ux-auditor rendered a site-wide page list and ignored ?page= entirely, and
   * page-watch read no parameters at all. A link that arrives asking for /pricing and lands on an
   * unfiltered list has lied to whoever clicked it — worse than a 404, because nothing looks wrong.
   *
   * These three put that right WITHOUT pretending the server filtered anything (none of those
   * endpoints accept a page filter): the row is found in what is already on screen, highlighted and
   * scrolled to, and a note says what happened — including when the honest answer is "that page is
   * not in this range".
   */
  GS.dlParam = function (name) {
    try { return new URLSearchParams(location.search).get(name) || ''; } catch (e) { return ''; }
  };

  /** Find + highlight the element carrying attr === value. Returns it, or null. */
  GS.focusDeepLink = function (scope, value, attr) {
    if (!scope || !value) return null;
    attr = attr || 'data-gs-page';
    /* Matched by iterating, not by a selector: a path contains / ? # and can contain quotes, and
       CSS.escape is not available in every browser this ships to. */
    var list = scope.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute(attr) !== value) continue;
      var hit = list[i];
      hit.classList.add('gs-dl-focus');
      try { hit.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      catch (e) { try { hit.scrollIntoView(); } catch (e2) {} }
      return hit;
    }
    return null;
  };

  /** The "you are looking at X — show all" strip. Built with DOM APIs, never innerHTML: the value
   *  came off the query string and is therefore attacker-controlled. */
  GS.deepLinkNote = function (scope, opts) {
    if (!scope) return null;
    var old = scope.querySelector('.gs-dl-note');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (!opts || !opts.value) return null;
    var param = opts.param || 'page';
    var n = document.createElement('div');
    n.className = 'gs-dl-note' + (opts.found ? '' : ' gs-dl-miss');
    var ic = document.createElement('i');
    ic.className = 'bi ' + (opts.found ? 'bi-crosshair' : 'bi-info-circle');
    var tx = document.createElement('span');
    tx.textContent = opts.found ? ('Focused on ' + opts.value)
      : (opts.missText || ('Nothing for ' + opts.value + ' in this range.'));
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'gs-dl-x'; btn.textContent = 'Show all';
    btn.addEventListener('click', function () {
      try {
        var qs = new URLSearchParams(location.search); qs.delete(param);
        var s = qs.toString();
        history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
      } catch (e) {}
      var lit = scope.querySelectorAll('.gs-dl-focus');
      for (var i = 0; i < lit.length; i++) lit[i].classList.remove('gs-dl-focus');
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    n.appendChild(ic); n.appendChild(tx); n.appendChild(btn);
    scope.insertBefore(n, scope.firstChild);
    return n;
  };

  /** Both of the above, for the common case. Call it after every render. */
  GS.applyPageDeepLink = function (scope, opts) {
    opts = opts || {};
    var param = opts.param || 'page';
    var value = GS.dlParam(param);
    if (!value || !scope) return null;
    var hit = GS.focusDeepLink(opts.within || scope, value, opts.attr);
    if (!hit && opts.within && opts.within !== scope) hit = GS.focusDeepLink(scope, value, opts.attr);
    GS.deepLinkNote(scope, { param: param, value: value, found: !!hit, missText: opts.missText });
    if (!hit && typeof opts.onMiss === 'function') { try { opts.onMiss(value); } catch (e) {} }
    return hit;
  };

  GS.normalizeDeepLink();

  document.dispatchEvent(new CustomEvent('gs:ready'));
});
